(function () {

  'use strict';

  eclipseApp.factory('prepaidUserInfoService', function() {

    var CTN = null,
      BAN = null,
      firstName = null,
      lastName = null,
      emailAddress = null,
      billingAddress = null;

    function setCTN(data) {
      CTN = data;
    }

    function getCTN() {
      return CTN;
    }

    function setBAN(data) {
      BAN = data;
    }

    function getBAN() {
      return BAN;
    }

    function setFirstName(data) {
      firstName = data;
    }

    function getFirstName() {
      return firstName;
    }

    function setLastName(data) {
      lastName = data;
    }

    function getLastName() {
      return lastName;
    }

    function setEmailAddress(data) {
      emailAddress = data;
    }

    function getEmailAddress() {
      return emailAddress;
    }

    function setBillingAddress(data) {
      billingAddress = data;
    }

    function getBillingAddress() {
      return billingAddress;
    }

    return {
      setCTN: setCTN,
      getCTN: getCTN,
      setBAN: setBAN,
      getBAN: getBAN,
      setFirstName: setFirstName,
      getFirstName: getFirstName,
      setLastName: setLastName,
      getLastName: getLastName,
      setEmailAddress: setEmailAddress,
      getEmailAddress: getEmailAddress,
      setBillingAddress: setBillingAddress,
      getBillingAddress: getBillingAddress
    };

  });

})();
